module.exports = __webpack_public_path__ + "static/media/clean10.3a1b805a.png";